
























import InputCheckBox from "@/common/components/atoms/InputCheckBox.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconDrinkStop from "@/common/components/icons/IconDrinkStop.vue";
import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    InputCheckBox,
    IconBase,
    IconDrinkStop
  }
})
export default class TheC01ItemFormNotePanelDrink extends Vue {
  @Prop({ type: Boolean, required: true, default: false }) value!: boolean;

  onCheckAdult() {
    this.$emit("checked");
  }
}
